package de.oevbs.kunde.kundenportal2.model.services.contact

import de.oevbs.businesspartner.bpcrmservice2.agent.model.Agent
import de.oevbs.businesspartner.bpcrmservice2.common.model.LineOfBusiness
import de.oevbs.kunde.kundenportal2.model.services.contact.types.ComplaintSubject
import de.oevbs.kunde.kundenportal2.model.services.contact.types.ContactMessageType
import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.Validation
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class MessageReference(
    val id: String = "",
    val text: String = "",
    val lineOfBusiness: LineOfBusiness = LineOfBusiness.Unbekannt
) {
    override fun toString(): String = text

    companion object
}

@Lenses
@Serializable
data class ContactMessageInit(
    val agent: Agent? = null,
    val contractRefs: List<MessageReference> = emptyList(),
    val claimRefs: List<MessageReference> = emptyList(),
) {
    companion object
}

@Lenses
@Serializable
data class ContactMessage(
    val type: String = "",
    val subject: String = "",
    val contract: MessageReference? = null,
    val claim: MessageReference? = null,
    val confirmation: Boolean = false,
    val complaintSubjects: List<String> = emptyList(),
    val complaintReasons: List<String> = emptyList(),
    val complaintSolution: String = "",
    val content: String = ""
) {
    companion object {
        val validation: Validation<ContactMessage, Unit, ComponentValidationMessage> = validation { inspector ->

            val type = inspector.map(ContactMessage.type())
            if (type.data.isBlank()) {
                add(type.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            }
            val selectedContract = inspector.map(ContactMessage.contract())
            if (type.data == ContactMessageType.CONTRACT_INFORMATION.text && selectedContract.data == null) {
                add(selectedContract.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            }

            val selectedClaim = inspector.map(ContactMessage.claim())
            if (type.data == ContactMessageType.LOSS_INFORMATION.text && selectedClaim.data == null) {
                add(selectedClaim.errorMessage(KupoValidationMessages.EMPTY_SELECT))
            }

            val confirmation = inspector.map(ContactMessage.confirmation())
            if ((type.data == ContactMessageType.CONTRACT_INFORMATION.text || type.data == ContactMessageType.LOSS_INFORMATION.text) &&
                !confirmation.data
            ) {
                add(confirmation.errorMessage("Bitte bestätigen Sie die Hinweise und Informationen."))
            }

            if (type.data == ContactMessageType.COMPLAINT_MESSAGE.text) {
                val subjects = inspector.map(ContactMessage.complaintSubjects())
                if (subjects.data.isEmpty()) {
                    add(subjects.errorMessage(KupoValidationMessages.EMPTY_SELECT))
                }
                val reasons = inspector.map(ContactMessage.complaintReasons())
                if (reasons.data.isEmpty()) {
                    add(reasons.errorMessage(KupoValidationMessages.EMPTY_SELECT))
                }

                if (subjects.data.contains(ComplaintSubject.CONTRACT.text)) {
                    if (selectedContract.data == null) {
                        add(selectedContract.errorMessage(KupoValidationMessages.EMPTY_SELECT))
                    }
                }

                if (subjects.data.contains(ComplaintSubject.LOSS_REGULATION.text)) {
                    if (selectedClaim.data == null) {
                        add(selectedClaim.errorMessage(KupoValidationMessages.EMPTY_SELECT))
                    }
                }

                val solution = inspector.map(ContactMessage.complaintSolution())
                if (solution.data.isEmpty()) {
                    add(solution.errorMessage(KupoValidationMessages.EMPTY_SELECT))
                }
            } else if (type.data == ContactMessageType.CONSULTANT_MESSAGE.text) {
                val subject = inspector.map(ContactMessage.subject())
                if (subject.data.isBlank()) {
                    add(subject.errorMessage(KupoValidationMessages.EMPTY_INPUT))
                }
            }

            val content = inspector.map(ContactMessage.content())
            if (content.data.isEmpty()) {
                add(content.errorMessage(KupoValidationMessages.EMPTY_INPUT))
            }
        }
    }
}